module.exports = __webpack_public_path__ + "static/media/worldometers.fd540364.jpg";